import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component({
	components: {},
})
export default class FlowchartLink extends Vue {
	@Prop()
	public id?: number;

	@PropSync('start', { default: [0, 0] })
	public localStart?: number[];

	@PropSync('end', { default: [0, 0] })
	public localEnd?: number[];

	@Prop({ default: { scale: 1 } })
	public options?: any;

	@Prop()
	public disabled?: boolean;

	public show: any = {
		delete: false,
	};

	public get pathStyle() {
		return {
			stroke: '#002C77',
			strokeWidth: 2.73205,
			fill: 'none',
		};
	}

	public get arrowStyle() {
		return {
			stroke: '#002C77',
			strokeWidth: 2,
			fill: 'none',
		};
	}

	public get arrowTransform() {
		// @ts-ignore
		const [arrowX, arrowY] = [this.localEnd[0], this.localEnd[1] - 12];
		const degree = 0;
		return `translate(${arrowX}, ${arrowY}) rotate(${degree})`;
	}

	public get deleteTransform() {
		const [deleteX, deleteY] = this.calculateCenterPoint();
		return `translate(${deleteX}, ${deleteY})`;
	}

	public get dAttr() {
		// @ts-ignore
		const cx = this.localStart[0];
		// @ts-ignore
		const cy = this.localStart[1];
		// @ts-ignore
		const ex = this.localEnd[0];
		// @ts-ignore
		const ey = this.localEnd[1] - 7;

		const dis = Math.min(Math.max(Math.abs(cx - ex), Math.max(0, cy - ey)), 100);
		// move to [cx, cy]
		// curve start pos bend [x, y]
		//       end pos bend [x, y]
		//       end pos [x, y]
		// https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
		return `M ${cx} ${cy} C ${cx} ${cy + dis} ${ex} ${ey - dis} ${ex} ${ey}`;
	}

	public handleMouseOver(e: any) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
		this.show.delete = true;
	}

	public handleMouseLeave(e: any) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
		this.show.delete = false;
	}

	public calculateCenterPoint() {
		// caculate arrow position: the center point between start and end
		// @ts-ignore
		const dx = (this.localEnd[0] - this.localStart[0]) / 2;
		// @ts-ignore
		const dy = (this.localEnd[1] - this.localStart[1]) / 2;
		// @ts-ignore
		return [this.localStart[0] + dx, this.localStart[1] + dy];
	}

	public deleteLink(e: any) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
		this.$emit('deleteLink', this.id);
	}
}
